import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography } from "@mui/material"
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { showSuccess } from "../../notifications/notificationsSlice";
import { unlockAppUser } from "../administration";
import { UnlockButton } from "../../../app/components/UnlockButton";
import { CancelButton } from "../../../app/components/CancelButton";

export interface UnlockUserDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const UnlockUserDialog = ({ email, onSuccessfullySaved, onCancel }: UnlockUserDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState(""); 

    const handleSubmitClick = async() => {
        try {
            setLoading(true)
            const result = await dispatch(unlockAppUser({ email }));
            if (unlockAppUser.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ status: "ACTIVE", lockedAt: "", lockedBy: "", lockReason: "" });
            } else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg)
            }
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-unblock-dialog-title">
                    <span>_Odblokuj użytkownika</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-unblock-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <UnlockButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}